var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagical54Color(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Magical-props",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "369.9px",
    height: "402.3px",
    viewBox: "0 0 369.9 402.3",
    style: {
      enableBackground: "new 0 0 369.9 402.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC933"
    },
    d: "M111.4,93.6l77.9,4.2c0,0,30.1-88.7,134.1-93.1c12,19.7,33.9,39.4,44.9,46 c-36.1,8.8-159.6,58.9-171.6,80.8c-18.9,20-101.9,18.8-116.2-5.3s30.9-31.4,30.9-31.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1461C"
    },
    d: "M192.2,18.8C196.1-6.1,101,1.5,97,6.8c0,0-2.4,5.7,4.6,10.8c0,0,8.5,33,10.7,60.3 c2.2,27.4-7.7,28.4,2.2,35c9.8,6.6,77.7,17.5,75.5-4.4C190,108.6,185.6,48.3,192.2,18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5FFF7"
    },
    d: "M180.7,141.1c0,0-3.7,26.7,11.4,48.5c58.6,35.1,77.7,82.1,73.3,108.3 c-8.3,150.8-254.6,127.2-263.7,0c-5.4-91.1,110.7-84.1,97.5-158.7C99.2,139.2,139,152.2,180.7,141.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF57AB"
    },
    d: "M47.9,274.5c-19,113.1,186.7,119.3,189.8,7.5c1.7-9-11-18.6-35.7-20.2 c-33.9-2.2-113.8-3.3-113.8-3.3S45.7,258.5,47.9,274.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.28
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.9,126.7c0,0,9.8-12.6,1.9-25.3c7.8-53.1,89.2-84.7,129.7-84.7c-4.2-6.1-8-12.2-8-12.2s-92.2-3.3-133.9,93.2 c0.5,3.7,0.5,10.8,0.5,10.8S203.7,111.2,199.9,126.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.28
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.8,3.1c0,0,20.6,15.9-0.9,22.5c1.4,7.5,8,65.6,0.5,96c-3.7,10.8-79.1,16.4-78.2-3.7s24.3-16.9,24.3-16.9v-6.6 c-43.6,3.9-55.2,51.1,33.7,51.5c32.8,0,53.8-12.2,54.8-19.2c0.5-7.5,3.7-13.1-9.8-18.3c-1.9-18.3-2.3-76.8,2.8-91.8 C192,12.4,190.6,6.8,165.8,3.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.28
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.3,143.5c-10.7,79.4,89.2,77.2,82,147.9c-7,46.8-35.6,100.2-104.9,108.2C249.7,409,333,273.7,192.1,189.5 c-9-14.9-12.7-24.5-11.8-49.4C177,141.7,165.3,143.5,165.3,143.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.28
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5,199.3c11.3-2.4,31-1.6,19.8,10.1s-40.1,4.3-52.9,27.8C59.3,221.8,80.6,202,93.5,199.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M96.9,6.8c0,0-6.6,15.3,35,18.6s73.3-3.3,56.9-15.3S105.7,0.3,96.9,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M101.5,17.8c0,0,8.6,32.8,10.8,60.1c2.2,27.4-7.7,28.4,2.2,35c9.8,6.6,77.7,17.5,75.5-4.4c0,0-4.4-60.2,2.2-89.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M111.5,94.8c0,0-45.2,7.3-30.9,31.4s97.1,25.5,116,5.5c0,0,12-16.4-6.6-23"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M189.4,97.8c0,0,30.1-88.7,134.1-93.1c12,19.7,33.9,39.4,44.9,46c-36.1,8.8-159.4,58.7-171.5,80.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M99.1,139.2C112.3,214-3.7,206.6,1.8,297.9c9.3,127.1,255.4,150.9,263.7,0c4.4-26.3-14.8-73.2-73.3-108.3 c-15.2-21.8-11.4-48.5-11.4-48.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M88.2,258.5c0,0-50.3,0-38.3,20.8s161.9,23,179.4,12c17.5-10.9,6.6-27.4-27.4-29.5C168.1,259.6,88.2,258.5,88.2,258.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M47.7,274.6c0,0-8.5,76.9,62.4,84.6c70,7.7,124.5-11.4,127.8-76.7"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.1,58.8c8.7-0.1,8.7,13.5,0,13.4C138.4,72.3,138.4,58.7,147.1,58.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.7,40.8c4.4-0.1,4.4,6.9,0,6.8C157.3,47.7,157.3,40.7,161.7,40.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.1,40.8c5.8-0.1,5.8,9.1,0,9C122.3,49.9,122.3,40.7,128.1,40.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.6,85.6c7.3-0.1,7.3,11.3,0,11.2C125.3,96.9,125.3,85.5,132.6,85.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagical54Color);
export default __webpack_public_path__ + "static/media/magical-54-color.24f323ae30fcf9b4432634225d44f869.svg";
export { ForwardRef as ReactComponent };